import { render, staticRenderFns } from "./projectTableExpand.vue?vue&type=template&id=23bfa201&scoped=true&"
import script from "./projectTableExpand.vue?vue&type=script&lang=js&"
export * from "./projectTableExpand.vue?vue&type=script&lang=js&"
import style0 from "./projectTableExpand.vue?vue&type=style&index=0&id=23bfa201&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bfa201",
  null
  
)

export default component.exports